/**
 * TS mirror of ad_image_variants.py's pure crop-math functions
 * (specs/completed/ad-image-aspect-variants.md, Known Risk 6).
 *
 * This mirror can drift from the Python source without consequence — it only
 * drives the CLIENT PREVIEW (PanCropViewport's frame + TextOverlayModal's
 * canvas). The actual output file is always produced server-side by the real
 * ad_image_variants.derive_crop. A drift here degrades the preview slightly;
 * it never produces a wrong file.
 */

export function cropWindowSize(srcW: number, srcH: number, targetW: number, targetH: number): [number, number] {
    const targetRatio = targetW / targetH;
    const srcRatio = srcW / srcH;
    let cw: number, ch: number;
    if (srcRatio > targetRatio) {
        cw = Math.round(srcH * targetRatio);
        ch = srcH;
    } else {
        cw = srcW;
        ch = Math.round(srcW / targetRatio);
    }
    cw = Math.min(cw, srcW);
    ch = Math.min(ch, srcH);
    return [cw, ch];
}

export function panAxisFor(srcW: number, srcH: number, targetW: number, targetH: number): 'x' | 'y' | 'none' {
    const [cw, ch] = cropWindowSize(srcW, srcH, targetW, targetH);
    if (srcW - cw > 0) return 'x';
    if (srcH - ch > 0) return 'y';
    return 'none';
}

export function panCropBox(
    srcW: number, srcH: number, targetW: number, targetH: number, panX: number, panY: number,
): [number, number, number, number] {
    const [cw, ch] = cropWindowSize(srcW, srcH, targetW, targetH);
    const clampedPanX = Math.max(0, Math.min(1, panX));
    const clampedPanY = Math.max(0, Math.min(1, panY));
    let left = Math.round(clampedPanX * (srcW - cw));
    let top = Math.round(clampedPanY * (srcH - ch));
    left = Math.max(0, Math.min(left, srcW - cw));
    top = Math.max(0, Math.min(top, srcH - ch));
    return [left, top, left + cw, top + ch];
}
